__turbopack_context__.v({
  "CardBlock": "B1jbDW_CardBlock",
  "CardBlock__inner": "B1jbDW_CardBlock__inner",
  "CardBlock__layout": "B1jbDW_CardBlock__layout",
  "CardItem": "B1jbDW_CardItem",
  "basic": "B1jbDW_basic",
  "basic_4": "B1jbDW_basic_4",
  "default": "B1jbDW_default",
  "default_4": "B1jbDW_default_4",
  "horizontal": "B1jbDW_horizontal",
  "text-center": "B1jbDW_text-center",
  "text-left": "B1jbDW_text-left",
  "text-right": "B1jbDW_text-right",
});
